<script lang="ts">
	import { format } from 'svelte-i18n';
	import { onMount } from 'svelte';
	import { querystring } from 'svelte-spa-router';
	import PVSetup from 'src/components/Consumption/PVSetupEnergy/PVSetup.svelte';
	import { ButtonV2, Modal, Text } from '@Shelly/shelly-design-system';

	let showModal = false;

	onMount(() => {
		if (new URLSearchParams($querystring).has('pvSetup')) {
			showModal = true;
		}
	});
</script>

<div class="d-flex gap-s justify-content-between align-items-center">
	<div>
		<Text styleType="body-medium" class="mb-xs">
			{$format('tab_pv_set_up', { default: 'PV Set-Up' })}
		</Text>
		<Text styleType="body-small" class="text-color-muted">
			{$format('settings_pv_setup_description', {
				default: 'Configure grid and solar meters for this home.',
			})}
		</Text>
	</div>

	<ButtonV2
		size="m"
		variant="secondary"
		aria-label={$format('button_open_pv_setup', { default: 'Open PV set-up' })}
		on:click={() => (showModal = true)}
	>
		{$format('button_open', { default: 'Open' })}
	</ButtonV2>
</div>

{#if showModal}
	<Modal
		{showModal}
		title={$format('tab_pv_set_up', { default: 'PV Set-Up' })}
		on:close={() => (showModal = false)}
	>
		<svelte:fragment slot="content">
			<PVSetup />
		</svelte:fragment>

		<div slot="footer" class="d-flex justify-content-end">
			<ButtonV2
				variant="secondary"
				size="m"
				aria-label={$format('button_close', { default: 'Close' })}
				on:click={() => (showModal = false)}
			>
				{$format('button_close', { default: 'Close' })}
			</ButtonV2>
		</div>
	</Modal>
{/if}
